$(function() {
  if($('.js-btn-completion').length) {
    $('.js-btn-completion').on('click',function(e) {
      let checkCompletion = window.confirm('成立で確定します。よろしいですか？');
      if(!checkCompletion) {
        e.preventDefault();
      }
    });
    $('.js-btn-failure').on('click',function(e) {
      let checkFailure = window.confirm('不成立で確定します。よろしいですか？');
      if(!checkFailure) {
        e.preventDefault();
      }
    });
  }
});